<template>
  <div class="foto-met-tekst-gallery-card" v-bind:class="rootClassName">
    <img :alt="imageAlt" :src="imageSrc" class="foto-met-tekst-image" />
    <h2 class="foto-met-tekst-text">{{ title }}</h2>
  </div>
</template>

<script>
export default {
  name: "FotoMetTekst",
  props: {
    title: {
      type: String,
      default: "Project Title",
    },
    imageSrc: {
      type: String,
      default:
        "https://images.unsplash.com/photo-1418065460487-3e41a6c84dc5?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDEyfHxmb3Jlc3R8ZW58MHx8fHwxNjI2MjUxMjg4&ixlib=rb-1.2.1&h=1200",
    },
    rootClassName: String,
    imageAlt: {
      type: String,
      default: "image",
    },
  },
};
</script>

<style scoped>
.foto-met-tekst-gallery-card {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.foto-met-tekst-image {
  width: 450px;
  height: 450px;
  object-fit: fill;
}

.foto-met-tekst-text {
  align-self: center;
  margin-top: var(--dl-space-space-halfunit);
  font-weight: 600;
  margin-bottom: var(--dl-space-space-halfunit);
}

@media (max-width: 767px) {
  .foto-met-tekst-gallery-card {
    flex-direction: column;
  }
}

@media (max-width: 479px) {
  .foto-met-tekst-image {
    width: 22rem;
    height: 22rem;
  }
}
</style>
